import styled from 'styled-components';
import { ReactComponent as ResetPasswordIllustration } from '../../../../assets/svg/reset-password.svg';
import { ResetPasswordControls } from './reset-password-controls';
import { ChangePasswordControl } from './change-password-controls';
import { IChangePasswordPayload } from 'modules/shared/queries';

interface IResetOrChangePasswordPaneProps {
    isReset: boolean;
    changePasswordHandler: (formData: IChangePasswordPayload) => Promise<any>;
}

const IllustrationWrapper = styled.div`
    width: 400px;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content:flex-start;
    align-items:center;
`;

export const ResetOrChangePasswordPane = (props: IResetOrChangePasswordPaneProps) => {
    const { isReset, changePasswordHandler } = props;

    return (
        <>
            <IllustrationWrapper>
                <ResetPasswordIllustration />
            </IllustrationWrapper>
            {isReset ? <ResetPasswordControls /> : <ChangePasswordControl changePasswordHandler={changePasswordHandler} />}

        </>
    );
};

